"use strict";
const Formsy = require('formsy-react');
Formsy.Form = Formsy.default;

export default Formsy;